module.exports = __webpack_public_path__ + "static/img/idCardFront.28ee047.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/idCardFront.jpg
// module id = 1W3O
// module chunks = 1